import { render, staticRenderFns } from "./social_app.vue?vue&type=template&id=b3784954&"
import script from "./social_app.vue?vue&type=script&lang=js&"
export * from "./social_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports